export default __webpack_public_path__ + "static/popup-b8b9b0d66c3ecb7e40c4045874206d59.jpg";